import { ReactNode, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Box } from '../UI/Box'
import { useDispatch, useSelector } from 'react-redux'
import { selectDismissableModal } from '../../modules/miscUi/selectors'
import QuestComplete from '../../page_components/Home/Season/QuestComplete'
import { setDismissableModal } from '../../modules/miscUi/actions'
import { stopPropagation } from '../EmbeddableModal'

export default function DismissableModal() {
  const dismissableModal = useSelector(selectDismissableModal)

  const dispatch = useDispatch()

  const [isDismissing, setIsDismissing] = useState(true)

  const dismissModal = useCallback(() => {
    if (!dispatch) return
    setIsDismissing(true)
    const timer = setTimeout(() => {
      setIsDismissing(false)
      dispatch(setDismissableModal(null))
    }, 300)
    return () => clearTimeout(timer)
  }, [dispatch])

  const [Content, setContent] = useState<ReactNode | null>(null)

  useEffect(() => {
    if (!dismissableModal) return
    setIsDismissing(false)
    setContent(
      dismissableModal === 'quest_complete' ? <QuestComplete /> : <>:skull"</>,
    )
  }, [dismissableModal])

  return (
    <Wrapper c onClick={dismissModal} isDismissing={isDismissing}>
      <Inner dc onClick={stopPropagation}>
        {Content}
      </Inner>
    </Wrapper>
  )
}

const Wrapper = styled(Box) <{ isDismissing: boolean }>`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s;
  ${({ isDismissing }) => !isDismissing && 'opacity: 1;'}
`

const Inner = styled(Box)`
  max-width: 400px;
  max-height: 480px;
  flex-direction: column;
  overflow-y: auto;
  align-items: center;
  border-radius: var(--units-12, 12px);
  border: 1px solid var(--stroke-secondary, #333);
  background: var(--surface-primary, #080808);
  @media (max-width: 400px) {
    max-width: calc(100vw - 32px);
  }
`
